export default {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Array, Date],
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    parent: {
      type: Object,
      default: () => null
    },
    helpTitle: {
      type: String,
      default: ""
    },
    helpText: {
      type: String,
      default: ""
    }
  },
  computed: {
    labelText() {
      return this.label ? this.label : this.humanize(this.id);
    },
    isValid() {
      if (!this.parent.$v.form[this.id]) return null;
      return this.parent.$v.form[this.id].$dirty
        ? !this.parent.$v.form[this.id].$error
        : null;
    },
    isRequired() {
      if (!this.parent.$v.form[this.id]) return false;
      var v = this.parent.$v.form[this.id];
      if (typeof v.required != "undefined") {
        return true;
      }
      if (typeof v.requiredIf != "undefined") {
        return this.parent.$v.form[this.id].$params.requiredIf.prop(
          this.parent.form
        );
      }
      if (typeof v.requiredIf != "undefined") {
        return this.parent.$v.form[this.id].$params.requiredUnless.prop(
          this.parent.form
        );
      }
      return false;
    }
  },
  methods: {
    input($e) {
      this.$emit("input", $e);
      if (this.parent.$v.form[this.id]) {
        this.parent.$v.form[this.id].$touch();
      }
    },
    humanize(str) {
      var frags = this.splitPascalCase(str);
      frags = frags.split("_");
      for (let i = 0; i < frags.length; i += 1) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    splitPascalCase(word) {
      var wordRe = /($[a-z])|[A-Z][^A-Z]+/g;
      return word.match(wordRe).join("_");
    }
  }
};
